// Url params - currently it is getting from MainView
export default function ParamsReducer(state = {}, action) {
  switch (action.type) {
    case "UPDATE_ROUTE":
      return action.params

    default:
      return state
  }
}
